import type { MiniProgramQrcodeParam } from '@/server/types'
import { getMiniProgramQrcode } from '@/server'

export function useMiniProgramQrcode() {
  const qrcode = ref('')

  async function getQrcode(params: MiniProgramQrcodeParam) {
    getMiniProgramQrcode(params).then((res) => {
      qrcode.value = `data:image/png;base64,${res.data}`
    })
  }

  return {
    qrcode,
    getQrcode,
  }
}
